import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { recordPageview } from "@/lib/api";

/**
 * Tracks public page views and sends them to /api/analytics/pageview.
 * Skips admin/dealer/auth/api routes to keep analytics focused on the
 * public marketing site (/michigan, /totalwirelessmasteragent, etc.).
 */
export function PageviewTracker() {
  const location = useLocation();
  const last = useRef("");

  useEffect(() => {
    const path = location.pathname || "/";
    // Skip non-public surfaces
    if (
      path.startsWith("/admin") ||
      path.startsWith("/dealer") ||
      path.startsWith("/login") ||
      path.startsWith("/register") ||
      path.startsWith("/api")
    ) {
      return;
    }
    // De-dupe rapid double-triggers (strict mode, etc.)
    if (last.current === path) return;
    last.current = path;
    recordPageview(path);
  }, [location.pathname]);

  return null;
}
